import React from "react";
import classes from './MapLegend..module.css';
import useScoreLevelColor from '../../../../../../../hooks/useScoreLevelColor'
import {levelsScoresColorData} from '../../../../../../../models/heatMapData'
import { useSelector } from "react-redux";

const MapLegend = () => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);

    const levelColor = useScoreLevelColor();
    return (
        <div className={`${classes.ColorMap} ${classes[direction]}`}>
            {levelsScoresColorData && levelsScoresColorData.map((s, index) => <div key={index} className={classes.ScoreColor}>
                <div className={classes.NumTxt}>{texts[levelColor(s.minScore+1, s.status).ScoreThreshold]?texts[levelColor(s.minScore+1, s.status).ScoreThreshold]:levelColor(s.minScore+1, s.status).ScoreThreshold}</div>
                <div className={`${classes.Square} ${ s.status ==="NotStarted" && classes.Border}`}
                    style={{
                        background: `${s.status ==="Completed" ? levelColor(s.minScore+1).BColor
                            : levelColor(s.minScore,  s.status).BColor}`
                    }}></div>
            </div>)}

        </div>
    )
}
export default MapLegend;